import './CoralQuoteCards.scss'

import { CoralCardsSlider } from '@websrc/App/Components/CoralCardsSlider/CoralCardsSlider'
import { CoralHeading } from '@websrc/App/Components/CoralHeading/CoralHeading'
import { CoralQuoteLarge } from '@websrc/App/Components/CoralQuoteLarge/CoralQuoteLarge'
import { mapCoralWebQuoteCards } from '@websrc/DataMappers/mapSpot'
import React, { FC, useCallback, useEffect, useRef, useState } from 'react'

type CoralQuoteCardsProps = ReturnType<typeof mapCoralWebQuoteCards>

export const CoralQuoteCards: FC<CoralQuoteCardsProps> = (props) => {
  const [maxHeight, setMaxHeight] = useState(0)

  const heightReports = useRef<number[]>([])

  const handleHeightReport = useCallback((height: number, index: number) => {
    heightReports.current[index] = height
    const newMaxHeight = Math.max(...heightReports.current)
    setMaxHeight(newMaxHeight)
  }, [])

  useEffect(() => {
    const handleResize = () => {
      setMaxHeight(0)
      heightReports.current = []
    }
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return (
    <div className={'category-coral-spot'}>
      <CoralHeading header={props.header} headerTag={'h2'} />
      <CoralCardsSlider centerVertical={true} forceRow={true} fullExpand={true}>
        {props.quotes.map((quote, index) => (
          <CoralQuoteLarge
            key={index}
            {...quote}
            setMaxHeight={(height) => handleHeightReport(height, index)}
            wrapperHeight={maxHeight > 0 ? maxHeight : undefined}
          />
        ))}
      </CoralCardsSlider>
    </div>
  )
}
